import { render, staticRenderFns } from "./NewProducer.vue?vue&type=template&id=414d8e68&"
import script from "./NewProducer.vue?vue&type=script&lang=js&"
export * from "./NewProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports